import React from 'react';
import { Link } from 'react-router-dom';
import EastIcon from '@mui/icons-material/East';

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  link?: string;
  backgroundImage?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description, link = '/shop', backgroundImage }) => {
  const to = link || '/shop';
  return (
    <div className="group relative overflow-hidden rounded-2xl sm:rounded-[2rem] min-h-[300px] sm:h-[340px] flex flex-col justify-end p-5 sm:p-8 pb-8 sm:pb-10 shadow-md">
      {/* Background Image */}
      {backgroundImage ? (
        <img 
          src={backgroundImage} 
          alt={title} 
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out" 
        />
      ) : (
        <div className="absolute inset-0 bg-primary w-full h-full" />
      )}
      
      {/* Gradient Overlay using brand primary color */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/50 to-transparent transition-opacity duration-300" />
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-start translate-y-2 group-hover:translate-y-0 transition-transform duration-500 ease-out">
        {/* Icon with CSS targeting for size to fix TS cloneElement error */}
        <div className="text-accent mb-3 [&>svg]:!text-4xl">
          {icon}
        </div>
        
        {/* Title */}
        <h3 className="text-lg sm:text-xl md:text-2xl font-extrabold text-white mb-2 leading-tight">
          {title}
        </h3>
        
        {/* Description (Visible on hover using CSS grid transition) */}
        <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-out">
          <p className="text-white/80 text-sm leading-relaxed overflow-hidden">
            {description}
          </p>
        </div>
        
        {/* Link using brand accent color */}
        <Link
          to={to}
          className="mt-5 inline-flex items-center gap-2 text-accent font-semibold text-sm tracking-widest uppercase hover:gap-3 transition-all duration-300"
        >
          LEARN MORE <EastIcon fontSize="small" />
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
